module.exports = __webpack_public_path__ + "img/4.1ebeee46.png";